// Influencer configuration data
window.influencerConfig = {
  // Note: All keys are lowercase to match the UTM medium parameter after toLowerCase() is applied
  
  // Теа Минкова - Instagram: @teaminkova
  "teaminkova": {
    name: "Теа Минкова",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/tea_profile_pic.jpg?v=1743520441",
    instagramHandle: "@teaminkova"
  },
  // Галя Симеонова - Instagram: @galia.simeonova_
  "galia.simeonova_": {
    name: "Галя Симеонова",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/galia_profile_pic.jpg?v=1743520441",
    instagramHandle: "@galia.simeonova_"
  },
  
  // Алекс (Ая) Минкова - Instagram: @aqminkova
  "aqminkova": {
    name: "Ая Минкова",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/aq_profile_pic.jpg?v=1743520442",
    instagramHandle: "@aqminkova"
  },
  
  // Мона Гочева - Instagram: @monagocheff
  "monagocheff": {
    name: "Мона Гочева",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/mona_profile_pic.jpg?v=1743520441",
    instagramHandle: "@monagocheff"
  },
  
  // Маги Томова - Instagram: @magi_tomova
  "magi": {
    name: "Маги Томова",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/magi_profile_pic.jpg?v=1743520441",
    instagramHandle: "@magi_tomova"
  },
  
  // Цвети - New influencer
  "cvetelinapetrova1": {
    name: "Цвети", // TODO: Add full name when available
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/cvetipetrova-profile-pic.jpg?v=1744113453",
    instagramHandle: "@cveti"
  },
  "kalina": {
    name: "Калина",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/452625142_1014876306764673_4702573688558935960_n.jpg?v=1743692860",
    instagramHandle: "@kalina"
  },
  "ivelina": {
    name: "Ивелина",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/ivelina_profile_pic.jpg?v=1743781224",
    instagramHandle: "@ivelinachoeva"
  },
  "mihaela": {
    name: "Михаела",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/mihaela_profile_pic.jpg?v=1743781298",
    instagramHandle: "@mihaela_zinoviev"
  },
  "magidjanavarova": {
    name: "Маги",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/magidjanavarova_profile_pic.jpg?v=1743781724",
    instagramHandle: "@magidjanavarova"
  },
  "valeri": {
    name: "Валери",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/valeri_profile_pic.jpg?v=1743784262",
    instagramHandle: "@valerieyordanova"
  },
  "ivomila": {
    name: "Иво",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/ivomila_profile_pic.jpg?v=1743783765",
    instagramHandle: "@ivomilavp"
  },
  "simona": {
    name: "Симона",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/simona_profile_pic.jpg?v=1743783904",
    instagramHandle: "@sk.simona"
  },
  "zarena": {
    name: "Zarena",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/Zarena_ZA_logo_afe18de1-26de-4ab5-848b-92cde3c5db4d.png?v=1671024204",
    instagramHandle: "@zarenabags"
  },
  "antoinettepepe": {
    name: "Антоанет",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/antoanette_profile_pic.jpg?v=1744192280",
    instagramHandle: "@antoinettepepe"
  },
  "raia_mett": {
    name: "Рая",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/raia_profile_pic.jpg?v=1744192279",
    instagramHandle: "@raia_met"
  },
  // Template for new influencers
  "example": {
    name: "Име на Инфлуенсър",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/default_profile_pic.jpg?v=1743520442",
    instagramHandle: "@example"
  }
};